const OggOpusDecoder = require("ogg-opus-decoder").OggOpusDecoderWebWorker;
const OpusDecoder = require("opus-decoder").OpusDecoderWebWorker;

const codecMap = {
	opus: OpusDecoder,
	"ogg/opus": OggOpusDecoder
};

module.exports = (codec) => {
	if(codecMap[codec] === undefined) {
		return;
	}

	const decoder = new codecMap[codec]({
		sampleRate: 24000,
		forceStereo: false
	});

	console.log(decoder);

	const audioCtx = window.audioCtx;

	const player = {
		samples: new Float32Array(0),

		_playing: false,
		_buffering: false, // True when timer scheduled, waiting to play

		_latency: 200,
		_jitterBuffer: 100, // Fixed offset for browser main thread jank

		_playRealtime: () => {
			if(player._playing) {
				return;
			}

			player._playing = true;

			const bufferSize = 256;

			const scriptNode = audioCtx.createScriptProcessor(bufferSize, 0, 1);

			scriptNode.addEventListener("audioprocess", (audioProcessingEvent) => {
				if(player._playing === false) {
					return;
				}

				const outputBuffer = audioProcessingEvent.outputBuffer;
				const outputData = outputBuffer.getChannelData(0);

				if(player.samples.length === 0) {
					scriptNode.disconnect(audioCtx.destination);
					player._playing = false;
					return;
				}

				if(player.samples.length < 256) {
					console.warn(`Buffer underflow: ${player.samples.length}/256 samples`);
				}

				// Copy available samples
				const available = Math.min(player.samples.length, 256);
				for(let i = 0; i < available; i++) {
					outputData[i] = player.samples[i];
				}
				// Zero-fill remainder to avoid clicks
				for(let i = available; i < 256; i++) {
					outputData[i] = 0;
				}

				player.samples = player.samples.slice(256);
			});

			scriptNode.connect(audioCtx.destination);
		},

		_playBuffer: (buffer) => {
			const myArrayBuffer = audioCtx.createBuffer(
				1,
				buffer.length,
				24000,
			);

			const chan = myArrayBuffer.getChannelData(0);

			buffer.forEach((sample, key) => {
				chan[key] = sample;
			});

			const source = audioCtx.createBufferSource();

			source.buffer = myArrayBuffer;

			source.connect(audioCtx.destination);

			source.start();
		},

		_concat: (buffer1, buffer2) => {
			const tmp = new Float32Array(buffer1.length + buffer2.length);

			tmp.set(new Float32Array(buffer1), 0);
			tmp.set(new Float32Array(buffer2), buffer1.length);

			return tmp;
		},

		_decode: (buffer) => {
			if(codec === "opus") {
				return decoder.decodeFrame(new Uint8Array(buffer));
			} else if (codec === "ogg/opus") {
				return decoder.decode(new Uint8Array(buffer));
			} else {
				throw new Error("Unknown codec " + codec);
			}
		},

		decode: (data) => {
			decoder.ready.then(() => {
				// Schedule playback timer once on first packet
				if(!player._playing && !player._buffering) {
					player._buffering = true;
					const bufferTime = 4 * player._latency + player._jitterBuffer;
					setTimeout(() => {
						player._buffering = false;
						player._playRealtime();
					}, bufferTime);
				}

				player._decode(data).then(decoded => {
					if(decoded.channelData[0] === undefined) {
						return;
					}

					player.samples = player._concat(player.samples, decoded.channelData[0]);
				});
			});
		},

		setLatency: latency => (player._latency = latency),

		isPlaying: () => player._playing,

		reset: () => {
			player._buffering = false;
			try {
				return decoder.reset();
			} catch(e) {
				console.error(e);
			}
		}
	};

	return player;
};
